var render = function render(){var _vm=this,_c=_vm._self._c;return _c('warning',{attrs:{"icon":"regular/lock-1","title":_vm.$t('unauthorized.title'),"content":_vm.$t('unauthorized.details'),"show-back":true,"show-home":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }